import App from "../../app";
import { OverviewScore } from "../../model/datasource/score";
import { SectionFrontend } from "../frontend";
import {
	AttemptId,
	ProductId,
	ItemId,
	QuizId
} from "../../model/datasource";
import { OverviewScoreChart } from "../../lib/chart";

export abstract class SectionView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> {
	frontend: SectionFrontend<Z, I>;

	constructor(frontend?: SectionFrontend<Z, I>) {
		this.frontend = frontend;
	}

	abstract init(app: App<P, A, Z, I>): void

	abstract displayOverviewScores(chart: OverviewScoreChart<A, Z>, scores: OverviewScore<A, Z>[]): void
	abstract toggleStart(element: HTMLElement): void
}

export class NullSectionView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> implements SectionView<P, A, Z, I> {
	frontend: SectionFrontend<Z, I>;

	init(app: App<P, A, Z, I>): void { }

	displayOverviewScores(chart: OverviewScoreChart<A, Z>, scores: OverviewScore<A, Z>[]): void {
		throw new Error("Method not implemented.");
	}

	toggleStart(element: HTMLElement): void {
		throw new Error("Method not implemented.");
	}
}

